import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { CubejsService } from 'app/shared/cubejs/cubejs.service';
import moment from 'moment';

@Component({
  selector: 'app-monthly-importer-summary',
  templateUrl: './monthly-importer-summary.component.html',
  styleUrls: ['./monthly-importer-summary.component.scss']
})
export class MonthlyImporterSummaryComponent implements OnInit {


  isCubejsConnected: boolean = true;
  startDate = new FormControl(moment().startOf('year').format('YYYY-MM-DD')); ì
  endDate = new FormControl(moment().format('YYYY-MM-DD')); 
  // startDate = new FormControl(moment().subtract(1, 'year').subtract(6, 'months').startOf('month').format('YYYY-MM-DD'));
  // endDate = new FormControl(moment().subtract(1, 'year').endOf('month').format('YYYY-MM-DD'));
  startDateString: string;
  endDateString: string;
  filters: Array<Object> = [];

  @ViewChild('worldMap', { static: false }) private mapContainer!: ElementRef;

  pageSizeOptions: number[] = [10, 50, 100];
  @ViewChild('aldiImporterPaginator') aldiImporterPaginator: MatPaginator;
  @ViewChild('aldiImporterMatSort') aldiImporterMatSort: MatSort;
  isLoadingAldiImporterData = false;
  hasNotData: boolean = false;
  aldiImporterData = [
    "vendor_name",
    "nr_wpu_connected",
    "number_wpu_below80",
    "percentageBelow80",
  ]

  aldiImporterDataList = new MatTableDataSource([]);
  importersList: any[] = [];
  // countryList: any[] = [];

  constructor(private cubejsService: CubejsService, private router: Router, private route: ActivatedRoute) { }


  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['startDate'] && params['endDate']) {
        this.startDate.setValue(params['startDate']);
        this.endDate.setValue(params['endDate']);
      }
      let std = new Date(this.startDate.value);
      let edd = new Date(this.endDate.value);
      this.startDateString = new Date(std.getFullYear(), std.getMonth(), std.getDate() + 1).toISOString().slice(0, 10);
      this.endDateString = new Date(edd.getFullYear(), edd.getMonth(), edd.getDate() + 1).toISOString().slice(0, 10);
      this.getAldiImporterData();
    });
  }





  
  getAldiImporterData() {
    this.isLoadingAldiImporterData = true;
    const query = {
      "dimensions": [
        "AldiNewReport.importer_name",
        "AldiNewReport.country_name"

      ],
      "timeDimensions": [
      ],
      "measures": [
        "AldiNewReport.supplier_count",
        "AldiNewReport.low_compliance_supplier_count",
        "AldiNewReport.medium_compliance_supplier_count"
      ],
      "filters": [
        {
          "member": "AldiNewReport.type_of_calc",
          "operator": "equals",
          "values": [
            "raw"
          ]
        },
        {
          "member": "Dummy.date",
          "operator": "inDateRange",
          "values": [
            this.startDateString,
            this.endDateString
          ]
        }

      ]
    }
    this.cubejsService.getCubeJSData(query, null, null, true, false)
      .then(data => {
        let tempData = data['loadResponse']['results'][0]['data'];
        if (tempData.length > 0) {
          this.hasNotData = false;
          tempData = this.changeKey("AldiNewReport.importer_name", "importer_name", tempData)
          tempData = this.changeKey("AldiNewReport.country_name", "country_name", tempData)
          tempData = this.changeKey("AldiNewReport.supplier_count", "supplier_count", tempData)
          tempData = this.changeKey("AldiNewReport.low_compliance_supplier_count", "low_compliance_supplier_count", tempData)
          tempData = this.changeKey("AldiNewReport.medium_compliance_supplier_count", "medium_compliance_supplier_count", tempData)
          tempData = this.changeKey("AldiNewReport.type_of_calc", "type_of_calc", tempData)
          tempData = this.changeKey("Dummy.date", "scan_date", tempData)
          tempData = tempData.map(obj => ({
            ...obj,
            low_medium_compliance_supplier_count: Number(obj.low_compliance_supplier_count || 0) + Number(obj.medium_compliance_supplier_count || 0),
            percentage: obj.supplier_count > 0 ? Number(obj.low_compliance_supplier_count || 0) + Number(obj.medium_compliance_supplier_count || 0)/obj.supplier_count: 0
          }));

        }
        else this.hasNotData = true;
        this.aldiImporterDataList.data = tempData;
        this.aldiImporterDataList.paginator = this.aldiImporterPaginator;
        this.aldiImporterDataList.sort = this.aldiImporterMatSort;
        this.isLoadingAldiImporterData = false;
        this.importersList = this.aldiImporterDataList.data.map(item => item.importer_name);
        // this.countryList = Array.from(new Set(this.aldiImporterDataList.data.map(item => item.country_name)));
      })
  }

  onRowClicked(row: any) {
    this.router.navigate(['/monthly-importer-analytics'], {
      queryParams: {
        importer: row.importer_name,
        supplierCount: row.supplier_count,
        startDate: this.startDateString,
        endDate: this.endDateString,
        importersList: this.importersList,
        // countryList: this.countryList
      },
    });
  }

  

  changeKey(originalKey: string, newKey: string, arr: Array<Object>) {
    var newArr = [];
    for (var i = 0; i < arr.length; i++) {
      var obj = arr[i];
      obj[newKey] = (newKey == "value" && obj[originalKey] === null) ? 0 : obj[originalKey];
      delete (obj[originalKey]);
      newArr.push(obj);
    }
    return newArr;
  }


  changeEndDate(event: MatDatepickerInputEvent<Date>) {
    if (event.value !== null) {
        let std = new Date(this.startDate.value);
        let edd = new Date(this.endDate.value);
        this.startDateString = new Date(std.getFullYear(), std.getMonth(), std.getDate() + 1).toISOString().slice(0, 10);
        this.endDateString = new Date(edd.getFullYear(), edd.getMonth(), edd.getDate() + 1).toISOString().slice(0, 10);
        // this.filters = this.filters.filter((el) => { return el['member'] !== "Formulas.scan_date" })
        this.getAldiImporterData();
    }
  }

}
